import React, { forwardRef, useState } from 'react';
import { IDocument } from '../../../Interfaces/IDocument';
import {
  Alert,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
} from '@mui/material';
import { ISystem } from '../../../Interfaces/ISystem';
import { ILegalTransactionFullObject } from '../../../Interfaces/ILegalTransaction';
import { uploadFetch } from '../../../hooks/useFetch';

interface IProps {
  legalTransaction: ILegalTransactionFullObject;
  documentObject: IDocument;
  disableBtn?: boolean;
}

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '35vh', // Zentriert vertikal
    fontFamily: 'sans-serif',
  },
  number: {
    fontSize: '6rem',
    fontWeight: 'bold',
  },
  label: {
    fontSize: '1.5rem',
    color: '#555',
  },
};

export const DocumentRequest = forwardRef<HTMLButtonElement, IProps>(
  ({ legalTransaction, documentObject, disableBtn }, ref) => {
    const [wasUsed, setWasUsed] = useState(false);
    const [isOpenWarning, setIsOpenWarning] = useState(false);

    const [isLoadingRequest, setIsLoadingRequest] = useState(false);
    const [wasUploaded, setWasUploaded] = useState(false);
    const [wasSuccessfully, setWasSuccessfully] = useState(true);

    const [isOpenRequest, setIsOpenRequest] = useState(false);

    const handleAfterUpload = () => {
      setWasUsed(true);
      setWasUploaded(true);
    };

    const handleRequestFiles = () => {
      setWasUploaded(false);
      setIsLoadingRequest(true);
      setIsOpenRequest(true);

      if (wasUsed) {
        setIsLoadingRequest(false);
        return;
      }

      localStorage.setItem('requested_data', 'true');
      const uploadSync: ISystem = {
        idContact: Number(localStorage.getItem('idContact')),
        idLegalTransaction: legalTransaction.idLegalTransaction,
        SyncType: 'RequestFiles',
        Data: [documentObject.idDocument],
      };
      uploadFetch(
        '/system',
        true,
        uploadSync,
        handleAfterUpload,
        setWasSuccessfully,
        () => {},
        setIsLoadingRequest
      );
    };

    return (
      <>
        {isOpenRequest && (
          <Dialog open maxWidth='xs' fullWidth>
            <DialogContent>
              {!wasUploaded && wasUsed ? (
                <Alert severity='info'>
                  Es kann bis zu fünf Minuten dauern, bis Ihre angeforderten
                  Dokumente bereitgestellt werden. Bitte haben Sie einen moment
                  Geduld.
                </Alert>
              ) : isLoadingRequest ? (
                <div style={styles.container}>
                  <div style={styles.label}>
                    <CircularProgress />{' '}
                  </div>
                </div>
              ) : wasSuccessfully === false ? (
                <Alert severity='error'>
                  Leider ist ein Fehler aufgetretten, versuchen Sie es später
                  erneut
                </Alert>
              ) : (
                <div style={styles.container}>
                  <div style={styles.label}>Ihre Dokumente werden </div>
                  <div style={styles.label}>in den nächsten </div>
                  <div style={styles.number}>5</div>
                  <div style={styles.label}>Minuten bereitgestellt.</div>
                </div>
              )}
            </DialogContent>
            {isLoadingRequest !== true && (
              <DialogActions>
                <Button
                  variant='contained'
                  onClick={() => setIsOpenRequest(false)}
                >
                  Schließen
                </Button>
              </DialogActions>
            )}
          </Dialog>
        )}

        <Button
          ref={ref}
          variant={wasUsed ? 'outlined' : 'contained'}
          onClick={handleRequestFiles}
          sx={{
            visibility:
              disableBtn === undefined || disableBtn === false
                ? undefined
                : 'hidden',
          }}
        >
          Anfordern
        </Button>
      </>
    );
  }
);
